import { ISkill } from 'src/types/skills';

export const SkillItems: string[] = [
    'Python',
    'React',
    'ReactNative',
    'aws_glue',
    'chalice',
    'cpp',
    'css',
    'django',
    'docker',
    'elastic',
    'fast_api',
    'feature',
    'firebase',
    'flutter',
    'go',
    'html',
    'javascript',
    'kotlin',
    'macbook',
    'next.js',
    'php',
    'postgres',
    'postgresql',
    'python',
    'qa_tasks',
    'qt',
    'react',
    'react_mobile',
    'react_native',
    'serverless',
    'storybook',
    'suitescript',
    'swift',
    'swift_ui',
    'tailwind_css'
];

export const SKILLS: ISkill[] = [
    { name: 'Python', percent: 12 },
    { name: 'React', percent: 14 },
    { name: 'React Native', percent: 19 },
    { name: 'Django', percent: 9 },
    { name: 'Next.js', percent: 19 },
    { name: 'StoryBook', percent: 10 },
    { name: 'Chalice', percent: 11 }
];
